import type { ButtonProps } from '@mui/material/Button';
import type { Components, Theme } from '@mui/material/styles';

export const MuiButton: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  defaultProps: {
    disableElevation: true,
  },
  styleOverrides: {
    root: ({ theme, ownerState }: { theme: Omit<Theme, 'components'>; ownerState: ButtonProps }) => ({
      textTransform: 'none',
      // contained + primary
      ...(ownerState.variant === 'contained' &&
        ownerState.color === 'primary' && {
          color: theme.palette.primary.contrastText,
          background: !ownerState.disabled ? '#07105F' : '',
          '&:hover': {
            background: '#0C21A3',
            transition: 'background 0.3s ease',
          },
          '&:active': {
            background: '#011BE6',
            transition: 'none',
          },
          transition: 'color 0.3s ease',
        }),
      // contained + secondary
      ...(ownerState.variant === 'contained' &&
        ownerState.color === 'secondary' && {
          color: '#020F20',
          background: '#E8EBF2',
          '&:hover': {
            background: '#D6DBE7',
          },
          '&:active': {
            background: '#A4ADBE',
          },
          transition: 'color 0.3s ease',
        }),
      // contained + inherit
      ...(ownerState.variant === 'contained' &&
        ownerState.color === 'inherit' && {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.paper,
          '&:hover': {
            background: theme.palette.action.focus,
          },
        }),
      // outlined + primary
      ...(ownerState.variant === 'outlined' &&
        ownerState.color === 'primary' && {
          borderColor: '#0D1B273B',
          color: theme.palette.text.primary,
          '&:hover': {
            borderColor: '#0D1B273B',
            backgroundColor: theme.palette.action.hover,
          },
          '&:active': {
            borderColor: '#0D1B273B',
            backgroundColor: theme.palette.action.focus,
          },
        }),
      // text + primary
      ...(ownerState.variant === 'text' &&
        ownerState.color === 'primary' && {
          color: theme.palette.text.primary,
        }),
      // disabled state
      ...(ownerState.disabled && {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.action.disabled,
      }),
    }),
    sizeLarge: {
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '26px',
      padding: '8px 22px',
    },
    sizeMedium: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      padding: '6px 16px',
    },
    sizeSmall: {
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22px',
      padding: '4px 10px 4px 10px !important',
    },
  },
};
